module.exports = __webpack_public_path__ + "0924dc178a2cf893e78dbafb705cd391.svg";